<ng-container *transloco="let t; prefix: translocoPrefix">
  <button nz-button nzType="primary" (click)="handleLogin()">
    {{ t('LOGIN') }}
  </button>
</ng-container>
